export interface DialogueLine {
  speaker: string;
  text: string;
}

export interface DialogueSet {
  id: string;
  zone: number;
  lines: DialogueLine[];
}

/** Dialog aktif — hanya yang dipakai alur quest (sesuai konsep). */
export const DIALOGUES: DialogueSet[] = [
  {
    id: 'zone1_narrator',
    zone: 1,
    lines: [
      {
        speaker: 'Narator',
        text: 'Untuk menyelesaikan misi, kamu perlu menyimak kisah legenda berikut. Dahulu kala di Kerajaan Peremban Panas, Bumi Raflesia, hiduplah seorang pahlawan legendaris bernama Bujang Awang Tabuang.',
      },
      {
        speaker: 'Narator',
        text: 'Suatu ketika, keadaan alam tampak tidak tenang. Ibundo Putri Rimas telah pergi lebih awal ke ladang yang terletak di pinggir bukit, melintasi hutan. Bujang merasakan ada yang tidak beres dengan alam dan harus segera menyusul Ibundo sebelum malapetaka besar terjadi.',
      },
    ],
  },
  {
    id: 'zone1_sign',
    zone: 1,
    lines: [
      {
        speaker: 'Papan Petunjuk 1',
        text: 'Misi: Temui Kakek Sakti untuk mendapatkan petunjuk rahasia mengenai lokasi Keris Pusaka.',
      },
    ],
  },
  {
    id: 'zone1_kakek_sakti',
    zone: 1,
    lines: [
      {
        speaker: 'Kakek Sakti',
        text: 'Wahai cucuku Bujang, alam sedang tidak tenang. Aku tidak bisa memberikan keris ini langsung padamu. Carilah tiga Keris Pusaka yang tersebar di sepanjang jalan menuju kebun. Setiap keris menyimpan rahasia alam untuk menghadapi bumi yang berguncang.',
      },
    ],
  },
  {
    id: 'zone1_rafflesia',
    zone: 1,
    lines: [
      {
        speaker: 'Rafflesia',
        text: 'Petunjuk pertama diperoleh. Segera menuju hutan dan cari Keris 1 di sepanjang jalur datar, dekat papan tanda alam.',
      },
    ],
  },
  {
    id: 'zone2_narrator',
    zone: 2,
    lines: [
      {
        speaker: 'Narator',
        text: 'Kamu kini memasuki area hutan. Perhatikan sekelilingmu, karena alam sering memberi isyarat lewat perilaku penghuninya.',
      },
    ],
  },
  {
    id: 'zone2_bujang',
    zone: 2,
    lines: [
      {
        speaker: 'Bujang Awang Tabuang',
        text: 'Tunggu, kenapa suasana hutan mendadak sunyi?',
      },
      {
        speaker: 'Bujang Awang Tabuang',
        text: 'Lihat! Kawanan kera turun dari pohon dan harimau berlarian keluar dari semak-semak menuju arah bawah bukit!',
      },
    ],
  },
  {
    id: 'zone2_narrator_animals',
    zone: 2,
    lines: [
      {
        speaker: 'Narator',
        text: 'Perilaku hewan yang gelisah dan bermigrasi menjauh dari area pegunungan merupakan tanda alami bahwa getaran besar akan segera datang.',
      },
    ],
  },
  {
    id: 'zone2_keris1',
    zone: 2,
    lines: [
      {
        speaker: 'Keris 1 (Petunjuk BMKG)',
        text: 'Menghindar dari pohon besar, perhatikan tempat Anda berpijak, dan perhatikan jika ada rekahan tanah.',
      },
    ],
  },
  {
    id: 'zone2_keris1_local',
    zone: 2,
    lines: [
      {
        speaker: 'Keris 1 (Bahasa Daerah)',
        text: 'Menei ubeu hani kading mako, kemelet tano ko midang, ngen kemelet ketao mên olo rekahan tano.',
      },
    ],
  },
  {
    id: 'zone2_rafflesia',
    zone: 2,
    lines: [
      {
        speaker: 'Rafflesia',
        text: 'Keris 1 berhasil ditemukan.',
      },
    ],
  },
  {
    id: 'zone2_earthquake_boom',
    zone: 2,
    lines: [
      {
        speaker: 'Narator',
        text: 'Boom! Tanah mulai bergetar hebat. Gempa bumi terjadi.',
      },
    ],
  },
  {
    id: 'zone2_earthquake_mission',
    zone: 2,
    lines: [
      {
        speaker: 'Misi',
        text: 'Gunakan navigasi untuk menjauhi pohon yang akan tumbang dan hindari retakan tanah, sesuai petunjuk Keris Pusaka 1.',
      },
    ],
  },
  {
    id: 'zone3_narrator',
    zone: 3,
    lines: [
      {
        speaker: 'Narator',
        text: 'Bujang sampai di Rumah Bubungan Lima (Rumah Kebun). Rumah Bubungan Lima merupakan rumah adat Bengkulu yang berbentuk rumah panggung, ditopang tiang, dan dibangun lebih tinggi dari permukaan tanah.',
      },
      {
        speaker: 'Narator',
        text: 'Bentuk ini secara tradisional membantu melindungi penghuni dari banjir, serangan hewan liar, serta memberi ketahanan yang lebih baik terhadap kondisi alam yang berisiko, termasuk gempa.',
      },
    ],
  },
  {
    id: 'zone3_rafflesia_keris2',
    zone: 3,
    lines: [
      {
        speaker: 'Rafflesia',
        text: 'Keris 2 berhasil ditemukan.',
      },
    ],
  },
  {
    id: 'zone3_keris2',
    zone: 3,
    lines: [
      {
        speaker: 'Keris 2 (Petunjuk BMKG dan BNPB)',
        text: 'Jangan mendekati dan masuk ke bangunan yang sudah terkena dampak gempa sebelum Anda yakin bangunan tersebut cukup kokoh.',
      },
    ],
  },
  {
    id: 'zone3_keris2_local',
    zone: 3,
    lines: [
      {
        speaker: 'Keris 2 (Bahasa Daerah)',
        text: "Jangan badekep ngen moso' ubeu hani keno imbas gempo sikelei ubeu io kukuh.",
      },
    ],
  },
  {
    id: 'zone3_question_board',
    zone: 3,
    lines: [
      {
        speaker: 'Papan Pertanyaan',
        text: 'Misi: Siapkan Tas Darurat. Pilih 10 item wajib yang harus dibawa sesuai panduan BNPB.',
      },
    ],
  },
  {
    id: 'zone3_distractor_feedback',
    zone: 3,
    lines: [
      {
        speaker: 'Narator',
        text: 'Barang ini tidak mendesak. Membawa terlalu banyak beban bisa memperlambat evakuasimu.',
      },
    ],
  },
  {
    id: 'zone4_narrator',
    zone: 4,
    lines: [
      {
        speaker: 'Narator',
        text: 'Bujang melanjutkan perjalanan menuju kebun utama. Di sebuah persimpangan, petunjuk terakhir menunggumu.',
      },
    ],
  },
  {
    id: 'zone4_rafflesia_keris3',
    zone: 4,
    lines: [
      {
        speaker: 'Rafflesia',
        text: 'Keris 3 berhasil ditemukan.',
      },
    ],
  },
  {
    id: 'zone4_keris3',
    zone: 4,
    lines: [
      {
        speaker: 'Keris 3 (Petunjuk BMKG)',
        text: 'Jauhi pantai dan tepi sungai, cari informasi resmi, jangan panik, dan selalu berdoa kepada Tuhan Yang Maha Esa.',
      },
    ],
  },
  {
    id: 'zone4_keris3_local',
    zone: 4,
    lines: [
      {
        speaker: 'Keris 3 (Bahasa Daerah)',
        text: 'Menei ubeu hani pantei ngen pinggir sangei, kemelet tano ko makau informasi hani resmi, jangan panik, ngen tetiap de\'ei do\'o ngen Tuhan Hani Mako Kuaso.',
      },
    ],
  },
  {
    id: 'zone4_sign_need_guide',
    zone: 4,
    lines: [
      {
        speaker: 'Narator',
        text: 'Papan ini berisi pertanyaan evakuasi. Temui petugas evakuasi dulu — dia akan memberi arahan sebelum kamu membacanya.',
      },
    ],
  },
  {
    id: 'zone4_question_board',
    zone: 4,
    lines: [
      {
        speaker: 'Papan Pertanyaan',
        text: 'Di depanmu ada dua jalur. Jalur mana yang paling tepat dipilih saat terjadi gempa di perbukitan?',
      },
    ],
  },
  {
    id: 'zone4_npc_guide',
    zone: 4,
    lines: [
      {
        speaker: 'Bujang Awang Tabuang',
        text: 'Permisi, Pak. Saya baru membaca petunjuk dari keris pusaka soal gempa di perbukitan. Apa yang harus saya lakukan di sini?',
      },
      {
        speaker: 'Petugas Evakuasi',
        text: 'Bagus, kamu sudah baca petunjuk keris. Di persimpangan ini ada dua jalur evakuasi — tepi sungai dan bukit terbuka.',
      },
      {
        speaker: 'Petugas Evakuasi',
        text: 'Sebelum memilih, baca dulu papan petunjuk di dekat persimpangan. Pahami situasinya, gabungkan dengan isi keris tadi, baru tentukan jalur yang paling aman.',
      },
    ],
  },
  {
    id: 'zone4_npc_guide_remind',
    zone: 4,
    lines: [
      {
        speaker: 'Petugas Evakuasi',
        text: 'Pergi ke papan petunjuk persimpangan di depan sana. Baca pertanyaannya dengan saksama — baru setelah itu kamu pilih jalur evakuasi.',
      },
    ],
  },
  {
    id: 'zone4_wrong_route',
    zone: 4,
    lines: [
      {
        speaker: 'Narator',
        text: 'Tindakan salah. Gempa di perbukitan bisa memicu longsor yang membendung sungai. Jika bendungan alami itu jebol, banjir bandang mendadak bisa menghanyutkanmu.',
      },
    ],
  },
  {
    id: 'zone4_safe_route',
    zone: 4,
    lines: [
      {
        speaker: 'Narator',
        text: 'Kamu berhasil. Area terbuka yang jauh dari lereng curam adalah tempat paling aman. Jalur bukit terbuka sudah bisa dilalui — segera menuju ke sana.',
      },
    ],
  },
  {
    id: 'zone5_narrator',
    zone: 5,
    lines: [
      {
        speaker: 'Narator',
        text: 'Bujang hampir sampai di lokasi Ibundo. Ingat prinsip Sekundang Setungguan: bahu-membahu dan saling membantu sesama.',
      },
      {
        speaker: 'Misi utama',
        text: 'Bantu warga di sepanjang jalan menuju titik aman agar semua selamat.',
      },
    ],
  },
  {
    id: 'zone5_meet_vulnerable',
    zone: 5,
    lines: [
      {
        speaker: 'Ibu Hamil',
        text: 'Mas… tolong kami. Perut saya sakit dan kaki gemetar — susah jalan ke lapangan terbuka.',
      },
      {
        speaker: 'Lansia',
        text: 'Nenek pun sama, Nak. Lutut lemas dan pandangan gelap-gelapan. Kami takut kalau ditinggal sendiri di sini.',
      },
      {
        speaker: 'Bujang Awang Tabuang',
        text: 'Tenang, Bu, Pak. Saya Bujang Awang Tabuang. Kita jalan bersama menuju titik kumpul aman — bahu-membahu, semua pasti selamat.',
      },
    ],
  },
  {
    id: 'zone5_npc_help',
    zone: 5,
    lines: [
      {
        speaker: 'Lansia',
        text: 'Anak muda… apa kamu sanggup menemani kami? Kami tidak kuat berjalan sendiri.',
      },
    ],
  },
  {
    id: 'zone5_wrong_action',
    zone: 5,
    lines: [
      {
        speaker: 'Narator',
        text: 'Tindakan kurang tepat. Dalam situasi darurat, kepedulian terhadap sesama sangat penting agar tidak ada yang tertinggal.',
      },
    ],
  },
  {
    id: 'zone5_help_success',
    zone: 5,
    lines: [
      {
        speaker: 'Narator',
        text: 'Keputusan tepat. Kamu menerapkan prinsip Sekundang Setungguan. Lansia dan ibu hamil mengikutimu — antar mereka ke titik kumpul aman.',
      },
    ],
  },
];

export function getDialogueById(id: string): DialogueSet | undefined {
  return DIALOGUES.find((d) => d.id === id);
}

export function getDialoguesByZone(zone: number): DialogueSet[] {
  return DIALOGUES.filter((d) => d.zone === zone);
}
